/**
 * Single source of truth for the company's legal/contact data — referenced from
 * jsonLd.ts, ContactDetails.tsx, and (via next-intl interpolation) the legal/FAQ
 * translation JSONs that quote the address inline. Change it here once.
 */
export const BUSINESS_INFO = {
  brandName: "Grundriss Schmiede",
  legalName: "ImmoMates GmbH",
  ceo: "Jan Heusinger",
  street: "Lilienstraße 19",
  postalCode: "20095",
  city: "Hamburg",
  country: "Deutschland",
  countryCode: "DE",
  /** Human-readable, used in visible text. */
  phoneDisplay: "+49 40 69639190",
  faxDisplay: "+49 40 69639192",
  /** Digits-only (plus leading +), safe for tel: links. */
  phoneHref: "+494069639190",
  faxHref: "+494069639192",
  email: "mail@grundriss-schmiede.de",
  vatId: "DE329099286",
  commercialRegister: "HRB 162124",
  foundingDate: "2020-03-30",
  googlePlaceId: "ChIJk3dUQOaPsUcRo4-6YtAGV9g",
} as const;
